

















































































import TextSection from '@/components/TextSection'
import Slideshow from '@/components/Slideshow'
import Gallery from '@/components/Gallery'
import IconBoxes from '@/components/IconBoxes'
import Cards from '@/components/Cards'
import LogoSlider from '@/components/LogoSlider'
import News from '@/components/News'
import ContactForm from '@/components/ContactForm'
import InfoBoxes from '@/components/InfoBoxes'
import Blog from '@/components/Blog'
import ButtonGroup from '@/components/ButtonGroup'

export default 
    name: 'BasicElement'
    
    components:
        TextSection: TextSection
        Slideshow: Slideshow
        Gallery: Gallery
        IconBoxes: IconBoxes
        Cards: Cards
        LogoSlider: LogoSlider
        News: News
        ContactForm: ContactForm
        InfoBoxes: InfoBoxes
        Blog: Blog
        ButtonGroup: ButtonGroup

    props: ['id']

    #watch:
    #    id: (val) ->
    #        @fields = @defaultFields()
    #        @getContent val

    data: ->
        documentId: '',
        ready: false
        fields: @defaultFields()

    computed:
        classObejct: ->
            'uk-element-light': @isDark,
            'uk-background-muted': @fields.background_color is 'gedeckt',
            'uk-background-primary': @fields.background_color is 'primär',
            'uk-background-secondary': @fields.background_color is 'sekundär'

        dividerClass: ->
            if @fields.divider is 'eingeschaltet' then 'cm-element-divider' else ''

        parallax: ->
            'bgy: -400' if @isParallax

        background_alignment: ->
            switch @fields.background_alignment
                when 'links' then 'left'
                when 'rechts' then 'right'
                else 'center'
        

        isDark: ->
            @fields.background_color is 'sekundär' or
            @fields.background_color is 'primär' or
            @fields.background_image.url and 
            @fields.background_color is 'standard'
        
        isParallax: ->
            @fields.background_image.url
            @fields.parallax_effect is 'eingeschaltet'

    methods:
        defaultFields: ->
            background_image: []
            background_blend: 'eingeschaltet'
            background_alignment: 'zentriert',
            parallax_effect: 'ausgeschaltet'
            divider: 'ausgeschaltet'
            slices: []

        setContent: (document) ->
            @fields = @defaultFields()
            @documentId = document.id
            fields = 
                background_image: document.data.background_image
                background_blend: document.data.background_blend
                background_color: document.data.background_color
                background_alignment: document.data.background_alignment
                parallax_effect: document.data.parallax_effect
                divider: document.data.divider
                slices: document.data.body
            $.extend @fields, fields
            @ready = true

        getContent: (id) ->
            @$prismic.client.query(@$prismic.Predicates.at 'document.id', id).then (response) =>
                if response
                    document = response.results[0]
                    document and @setContent document  
                window.prismic.setupEditButton()      
    
    created: ->
        @getContent @id

